export const API_ENDPOINT = 'http://104.236.126.245';



// WEBPACK FOOTER //
// ./src/constants/api_endpoint.ts